export default __webpack_public_path__ + "static/media/redBanner.d037be63.jpg";